module.exports = __webpack_public_path__ + "688511da6741ef421fa9e7d8bb89b8b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/pinterest_2023_chart.png
// module id = 1705
// module chunks = 0